import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import { apiZodios } from '~api/apiZodios'
import { EnrichedOrganizationAISettings } from '~types'

import SearchView from './SearchView'

const SearchEmbedScreen: React.FC = () => {
  const [searchParams] = useSearchParams()
  const { organizationHandle } = useParams<{ organizationHandle: string }>()
  const isEmbedded = searchParams.has('embed')
  const isIframe = searchParams.has('iframe')
  const testing = searchParams.has('testing')
  const isInline = searchParams.has('inline')
  const showLogo = searchParams.has('logo')
  const initialQuery = searchParams.get('query') || ''
  const [orgAiSettings, setOrgSettings] = useState<EnrichedOrganizationAISettings>()
  const [suggestions, setSuggestions] = useState<string[]>([])

  const initializeAI = async (): Promise<void> => {
    try {
      const response = await apiZodios.ai_initializeAI({
        organization_handle: organizationHandle,
      })
      setOrgSettings(response.organization_ai_settings)

      const texts = response.suggestions.map((suggestion) => suggestion.text)
      if (texts.length == 0) {
        const sugg =
          response.organization_ai_settings.organization_type === 'OrganizationCity'
            ? 'Ask a question (e.g. "Where is city hall?")'
            : response.organization_ai_settings.organization_type === 'OrganizationCounty'
              ? 'Ask a question (e.g. "Where is the county administration building?")'
              : 'Ask a question'

        const fallBackSuggs = [
          sugg,
          'How do I get a building permit?',
          `Why should I live in ${response.organization_ai_settings.organization_name}?`,
          'When is my trash picked up?',
        ]
        setSuggestions(fallBackSuggs)
      } else {
        setSuggestions(texts)
      }
    } catch (error) {
      console.error('Error initializing AI:', error)
    }
  }

  useEffect(() => {
    initializeAI()
  }, [organizationHandle])

  if (!orgAiSettings) {
    return null
  }

  if (isIframe) {
    const currentUrl = window.location.href
    const embedUrl = currentUrl.replace('iframe', 'embed')

    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '768px',
          }}
        >
          <iframe
            title='polimorphic-search'
            aria-label='Polimorphic Search'
            src={embedUrl}
            style={{
              width: '100%',
              height: '600px',
              border: 'none',
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <SearchView
      orgAiSettings={orgAiSettings}
      suggestions={suggestions}
      isEmbedded={isEmbedded}
      testing={testing}
      initialQuery={initialQuery}
      isInline={isInline}
      showLogo={showLogo}
    />
  )
}

export default SearchEmbedScreen
